import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    coupled: 'Married / Civil partnership',
    familySituation: 'Family status',
    no: 'No',
    numberOfChildren: 'Number of dependent children in the tax household',
    otherIncome: 'Total amount of other taxable household income',
    single: 'Single / Divorced / Cohabiting',
    singleParent: 'Do you live alone with your children?',
    subtitle: 'Information about your tax household',
    title: 'Standard scale',
    widowed: 'Widow(er)',
    yes: 'Yes',
  },
  fr: {
    coupled: 'Marié·es / Pacsé·es',
    familySituation: 'Situation familiale',
    no: 'Non',
    numberOfChildren: 'Nombre d’enfants à charge du foyer fiscal',
    otherIncome: 'Montant total des autres revenus imposables du foyer fiscal',
    single: 'Célibataire / Divorcé·e / Union libre',
    singleParent: 'Vivez-vous seul avec vos enfants ?',
    subtitle: 'Informations relatives à votre foyer fiscal',
    title: 'Barème standard',
    widowed: 'Veuf·ve',
    yes: 'Oui',
  },
} as const);
